import script from "./CloseIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./CloseIcon.vue?vue&type=script&lang=ts&setup=true"

import "./CloseIcon.vue?vue&type=style&index=0&id=51c2829c&lang=scss&scoped=true"

import exportComponent from "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c2829c"]])

export default __exports__